import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
    ui_social_icon__button: {
        "&:hover": {
            opacity: 0.8,
        },
    },
}));
//# sourceMappingURL=ui_social_button.css.js.map